import React, { useState, useEffect } from 'react';
import { managementAPI } from '../api';
import './UsersManagement.css';

const UsersManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [skip, setSkip] = useState(0);
  const [limit] = useState(100);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    loadUsers();
  }, [skip]);

  const loadUsers = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await managementAPI.getUsers(skip, limit);
      setUsers(response.data.users || []);
      setTotal(response.data.total || 0);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка загрузки пользователей');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="users-management">
      <header className="page-header">
        <h1>Управление пользователями</h1>
      </header>

      <div className="container-fluid">
        {error && <div className="error">{error}</div>}
        
        {loading && <div className="loading">Загрузка...</div>}
        
        {!loading && (
          <>
            <div className="users-info">
              <span>Всего пользователей: {total}</span>
            </div>

            <div className="card">
              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Email Verified</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {users.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="no-data">Нет пользователей</td>
                    </tr>
                  ) : (
                    users.map((user) => (
                      <tr key={user.id}>
                        <td>{user.id}</td>
                        <td>{user.username}</td>
                        <td>{user.email || 'N/A'}</td>
                        <td>
                          {user.is_email_verified ? (
                            <span className="status-healthy">Да</span>
                          ) : (
                            <span className="status-unreachable">Нет</span>
                          )}
                        </td>
                        <td>
                          {user.created_at
                            ? new Date(user.created_at).toLocaleString()
                            : 'N/A'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button
                onClick={() => setSkip(Math.max(0, skip - limit))}
                disabled={skip === 0}
                className="btn btn-secondary"
              >
                Предыдущие
              </button>
              <span className="pagination-info">
                Показано {skip + 1}-{Math.min(skip + limit, total)} из {total}
              </span>
              <button
                onClick={() => setSkip(skip + limit)}
                disabled={skip + limit >= total}
                className="btn btn-secondary"
              >
                Следующие
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UsersManagement;


